import { createFileRoute, redirect, useParams } from '@tanstack/react-router';
import { CompareScmWithOrderPage } from '@/app/(client)/supply-chain-mapping/-components/CompareScmWithOrderPage';
import { ensurePermissions } from '@/hooks/usePermissions';
import { PLATFORM_FEATURES } from '@/lib/constants/features';
import { hasFeature } from '@/lib/utils/features';
import { bootstrapSession } from '@/lib/utils/session';
import { useSessionStore } from '@/store/sessionStore';

export const Route = createFileRoute(
  '/(client)/supply-chain-mapping/(pages)/(details)/supply-chains/$id/compare/',
)({
  beforeLoad: async ({ params }) => {
    const toDiagram = redirect({
      to: '/supply-chain-mapping/supply-chains/$id/diagram',
      params: { id: params.id },
    });
    const user = useSessionStore.getState().user ?? (await bootstrapSession());
    if (!hasFeature(user, PLATFORM_FEATURES.CASCADE_TRACING)) {
      throw toDiagram;
    }
    const perms = await ensurePermissions();
    if (!perms.orders.canRead) {
      throw toDiagram;
    }
  },
  component: CompareScmWithOrderRoute,
});

function CompareScmWithOrderRoute() {
  const { id } = useParams({ strict: false }) as { id: string };
  return <CompareScmWithOrderPage collaborationId={id} />;
}
